import { useFetchMembershipStatus } from '@/api/hooks/useFetchMembershipStatus'
import { analytics } from '@/lib/analytics'
import { PhotoBlock } from '@/ui/core/block'
import { Button, ButtonText } from '@/ui/core/button'
import { FlowHeader } from '@/ui/core/flow-header'
import { Header } from '@/ui/core/header'
import { PageShell } from '@/ui/core/page-shell'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Redirect, router } from 'expo-router'
import Images from '#/assets/images/image-map'

const REACTIVATE_DRAFT = "Hi! I'd like to reactivate my membership."

const InactiveMembershipScreen = () => {
	const { hasActiveMembership } = useFetchMembershipStatus()
	const onChatPressed = () => {
		analytics.trackClick('reactivate_membership_button_pressed')
		router.push({ pathname: '/support', params: { draft: REACTIVATE_DRAFT } })
	}

	if (hasActiveMembership) {
		return <Redirect href="/" />
	}

	return (
		<Screen preset="fixed" className="flex flex-1" safeAreaEdges={['top']}>
			<FlowHeader />
			<PageShell flush photo={Images.BrandPhoto}>
				<VStack className="flex-1" gap={32}>
					<PhotoBlock source={Images.Product} height={260} scrim={0.12}>
						<Header variant="h1" tone="white">
							Paused
						</Header>
					</PhotoBlock>
					<VStack gap={16}>
						<Header variant="h3">Your membership is inactive</Header>
						<Text>
							Don't worry though! Chat with your Care Team and we'll get you set up again
							in no time.
						</Text>
					</VStack>
					<Button fullWidth={false} onPress={onChatPressed}>
						<ButtonText>Chat with us</ButtonText>
					</Button>
				</VStack>
			</PageShell>
		</Screen>
	)
}

export default InactiveMembershipScreen
